import React from "react"
import TemplateForm from "./TemplateForm";

export function TemplateCreate() {


    return <TemplateForm mode={"create"}/>




}